import { render, staticRenderFns } from "./CredenciamentoEsclarecimentoImpugnacao.vue?vue&type=template&id=50e538a5&scoped=true"
import script from "./CredenciamentoEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./CredenciamentoEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=50e538a5&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e538a5",
  null
  
)

export default component.exports